import './styles.scss';


export default function Badge({ text, leftIcon, rightIcon, variant="", className="" }) {
    return (
        <div className={`badge ${variant} ${className}`}>
            {leftIcon && <div className="left-icon">{leftIcon}</div>}
            <span className="text">{text}</span>
            {rightIcon && <div className="right-icon">{rightIcon}</div>}
        </div>
    );
}